<template>
  <div class="space-bottom">
    <div class="transblack-background"/>
    <jFloatingPrompt
      ref="titleFloating"
      class="p__b--100">
      <b-row class="jobTitleFloat">
        <b-col>
          <h3 class="c--blue">{{ detail_sla.name }}</h3>
          <br>
          <!-- eslint-disable-next-line -->
          <!-- <b-form-group :class="{ 'error-input' : $v.flow_sla.flow.$error }">
            <label>Name *</label>
            <j-single-select
              v-model="$v.flow_sla.flow.$model"
              :options="null"
              value-format="object"
              placeholder="name"
              label="name"/>
          </b-form-group> -->
          <b-form-group :class="{'error-input' : $v.flow_sla.duration.$error}">
            <label>Duration (minutes) *</label>
            <j-input
              v-model="$v.flow_sla.duration.$model"
              :max-length="25"
              type="number"
              placeholder="Duration"/>
          </b-form-group>
          <!-- <b-form-group :class="{'error-input' : $v.flow_sla.sla.$error}"> -->
          <div class="c--blue">SLA Indicator</div>
          <br>
          <div
            v-for="(type, index) in $v.flow_sla.sla.$each.$iter"
            :key="type.type.$model">
            <b-row>
              <b-col cols="3">
                <div class="m__t--7">
                  <j-checkbox
                    v-model="type.is_check.$model"
                    :checked="type.is_check.$model"
                    :disabled="false"
                    :checked-value="true"
                    :unchecked-value="false">
                    Type {{ Number(index) }} (%)
                  </j-checkbox>
                </div>
              </b-col>
              <b-col>
                <b-form-group :class="{'error-input' : type.value.$error}">
                  <j-input
                    v-model.number="type.value.$model"
                    :max-length="3"
                    :disabled="!type.is_check.$model"
                    type="number"
                    placeholder="Duration"/>
                </b-form-group>
              </b-col>
            </b-row>

          </div>
          <!-- </b-form-group> -->
        </b-col>
        <b-col cols="2">
          <!-- button create -->
          <div class="wrap-button-flow">
            <b-button
              class="btn blue"
              @click="createFlowSLA">
              SUBMIT
            </b-button>
            <i
              class="fa fa-times"
              @click="$refs.titleFloating.hide('/flows')"/>
          </div>
        </b-col>
      </b-row>
    </jFloatingprompt>
  </div>
</template>

<script>
import jFloatingPrompt from '@/components/new-floating-templete/jFloatingPrompt';
import { mapActions, mapState } from 'vuex';
import jMixValidationSLA from '@/mixins/validations/flow/jMixValidationSLA';
import jMixModeDetailSLA from '@/mixins/mode-form/flow/jMixModeDetailSLA';
// eslint-disable-next-line
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';

export default {
  components: {
    jFloatingPrompt,
  },
  mixins: [
    jMixValidationSLA,
    jMixModeDetailSLA,
  ],
  data() {
    return {
      mode: 'create',
      flow_sla: {
        duration: null,
        sla: [
          {
            id: 0,
            is_check: false,
            type: 1,
            value: null,
            is_delete: false,
          },
          {
            id: 0,
            is_check: false,
            type: 2,
            value: null,
            is_delete: false,
          },
          {
            id: 0,
            is_check: false,
            type: 3,
            value: null,
            is_delete: false,
          },
        ],
      },
    };
  },
  computed: {
    ...mapState('jStoreFlows', ['detail_sla', 'sla_created', 'sla_updated']),

    generate_data() {
      const sla = this.flow_sla.sla.filter(data => data.is_check === true);
      return {
        flow_id: this.detail_sla.id,
        duration: this.flow_sla.duration,
        sla,
      };
    },

  },

  watch: {
    sla_created() {
      this.$router.replace('/flows');
    },

    sla_updated() {
      this.$router.replace('/flows');
    },
  },

  methods: {
    ...mapActions('jStoreFlows', ['getDetailSLA']),
    generateDataEdit() {
      const sla = this.flow_sla.sla.filter(data => data.is_check === true);

      this.detail_sla.sla.forEach((slaData) => {
        let isAvailable = false;
        sla.forEach((listSla) => {
          if (listSla.id === slaData.id) {
            isAvailable = true;
          }
        });
        if (!isAvailable) {
          const dataDelete = {
            id: slaData.id,
            value: slaData.value,
            type: slaData.type,
            is_delete: true,
          };
          sla.push(dataDelete);
        }
      });

      return {
        flow_id: this.detail_sla.id,
        duration: this.flow_sla.duration,
        sla,
      };
    },

    createFlowSLA() {
      this.$v.flow_sla.$touch();
      if (!this.$v.flow_sla.$error) {
        // const createOrEdit = this.mode === ''
        const text = `You want to ${this.mode} Flow SLA in "${this.detail_sla.name}"`;

        this.$swal({
          title: 'Are you sure?',
          text,
          type: 'question',
          showCancelButton: true,
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
        }).then((result) => {
          if (result.value) {
            if (this.mode === 'create') {
              this.$store.dispatch('jStoreFlows/createFlowSLA', this.generate_data);
            } else {
              this.$store.dispatch('jStoreFlows/updateFlowSLA', this.generateDataEdit());
            }
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/flow-rule/flow/flow-sla/detail/jDetailFlowSLA.vue